import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

import vendCat1 from "../../../assets/Images/Vend_Cat1.png";
import vendCat2 from "../../../assets/Images/Vend_Cat2.png";
import vendCat3 from "../../../assets/Images/Vend_Cat3.png";
import vendCat4 from "../../../assets/Images/Vend_Cat4.png";

const categories = [
  { id: 1, title: "Street Food", image: vendCat1 },
  { id: 2, title: "Fresh Produce", image: vendCat2 },
  { id: 3, title: "Handicrafts", image: vendCat3 },
  { id: 4, title: "Textiles & Fabrics", image: vendCat4 },
];

const VendorCategoriesSection = () => {
  const theme = useTheme();
  const home = useSelector((state) => state.cms.home);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isMediumGrid = useMediaQuery("(min-width:900px) and (max-width:1389.95px)");
  const isDesktop = useMediaQuery("(min-width: 1390px)");

  const sections = Array.isArray(home?.data) ? home.data : [];
  const vendorCategoriesCms = sections.find((item) => {
    if (!item) return false;
    const isActive = item.status === 1 || item.status === true;
    if (!isActive) return false;
    return String(item.title || "").toLowerCase().includes("vendor categories");
  });

  const sectionHeading = vendorCategoriesCms?.sub_title || "What Products Can You Buy From Our Vendors?";
  const sectionDescription =
    vendorCategoriesCms?.description ||
    "Every vendor has a story. Buy their products and we'll distribute them to partner NGOs - empowering the vendor and supporting the community.";

  const cmsCategories = Array.isArray(vendorCategoriesCms?.relatedCMS)
    ? vendorCategoriesCms.relatedCMS
        .filter((item) => item && (item.status === 1 || item.status === true))
        .map((item) => ({
          id: item.id,
          title: item.title || "",
          image: item.image || vendCat1,
        }))
    : [];

  const categoriesData = cmsCategories.length > 0 ? cmsCategories : categories;

  return (
    <Box
      sx={{
        width: isMobile ? "100%" : "94.44%",
        maxWidth: "1440px",
        mx: "auto",
        mb: isMobile ? "30px" : "60px",
        px: isMobile ? "16px" : 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? "13px" : "12px", mb: isMobile ? "14px" : "16px" }}>
        <Box sx={{ width: "8px", height: "8px", borderRadius: "50%", background: "#8EA946" }} />
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: isMobile ? "10px" : "14px",
            lineHeight: isMobile ? 1 : "18px",
            letterSpacing: isMobile ? "2px" : "2.1px",
            textTransform: "uppercase",
            color: "#131313",
          }}
        >
          Vendors Categories
        </Typography>
      </Box>

      <Typography
        sx={{
          fontWeight: 700,
          fontSize: isMobile ? "18px" : "36px",
          lineHeight: isMobile ? "29.124px" : "50px",
          letterSpacing: isMobile ? "-0.36px" : "-0.36px",
          color: "#1D1D1B",
          mb: isMobile ? "10px" : "12px",
          maxWidth: isMobile ? "311px" : "none",
        }}
      >
        {sectionHeading}
      </Typography>

      <Typography
        sx={{
          fontWeight: 400,
          fontSize: isMobile ? "12px" : "16px",
          lineHeight: isMobile ? "19.416px" : "24px",
          letterSpacing: isMobile ? "-0.24px" : "normal",
          color: isMobile ? "#7E7878" : "#7D7D7D",
          mb: isMobile ? "20px" : "24px",
          maxWidth: isMobile ? "314px" : "none",
        }}
      >
        {sectionDescription}
      </Typography>

      <Box
        className="hide-scrollbar"
        sx={{
          display: isMobile ? "flex" : isDesktop || isMediumGrid ? "grid" : "flex",
          flexDirection: isMobile ? "column" : "row",
          gridTemplateColumns: isDesktop ? "repeat(4, minmax(0, 1fr))" : isMediumGrid ? "repeat(2, minmax(0, 1fr))" : "none",
          justifyContent: isDesktop || isMediumGrid ? "stretch" : "flex-start",
          gap: isMobile ? "10px" : "24px",
          overflowX: isMobile ? "hidden" : isDesktop || isMediumGrid ? "hidden" : "auto",
          overflowY: "hidden",
          pb: isDesktop || isMediumGrid ? 0 : "4px",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {categoriesData.map((item) => (
          <Box
            key={item.id}
            sx={{
              width: isMobile ? "100%" : isDesktop || isMediumGrid ? "100%" : isTablet ? "320px" : "270px",
              minWidth: isMobile ? "100%" : isDesktop || isMediumGrid ? 0 : isTablet ? "320px" : "270px",
              height: isMobile ? "210px" : isDesktop ? "340px" : isMediumGrid ? "330px" : isTablet ? "320px" : "280px",
              borderRadius: isMobile ? "11.938px" : "12.645px",
              overflow: "hidden",
              position: "relative",
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={item.title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: isMobile ? "center 30%" : "center",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                px: isMobile ? "11.616px" : "12.304px",
                py: isMobile ? "13.552px" : "14.354px",
                background: "rgba(0,0,0,0.5)",
                backdropFilter: isMobile ? "blur(14.925px)" : "blur(15.808px)",
                WebkitBackdropFilter: isMobile ? "blur(14.925px)" : "blur(15.808px)",
                borderRadius: isMobile ? "0 0 11.94px 11.94px" : "0 0 12.647px 12.647px",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: isMobile ? "14px" : "14.354px",
                  lineHeight: isMobile ? "19.319px" : "20.462px",
                  color: "#FFFFFF",
                }}
              >
                {item.title}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default VendorCategoriesSection;
